import { ListCalendarEventsParamsType } from './types';

export const AppointmentTypesQueryKeys = {
  getAppointmentTypes: (locationId: string, page?: string, limit?: string, searchValue?: string) => [
    'appointmentTypes',
    locationId,
    page,
    limit,
    searchValue,
  ],
  getAppointmentTypesMultiLocation: (
    locationIds: string[],
    parentLocationId: string,
    page?: string,
    limit?: string,
    searchValue?: string
  ) => ['appointmentTypesMultiLocation', ...locationIds, parentLocationId, page, limit, searchValue],
};

export const PractitionerQueryKeys = {
  getPractitionersList: (locationId: string, page?: string, limit?: string, searchValue?: string) => [
    'practitioners',
    locationId,
    page,
    limit,
    searchValue,
  ],
  getPractitionersListForMultiLocation: (
    locationIds: string[],
    parentLocationId: string,
    page?: string,
    limit?: string,
    searchValue?: string
  ) => ['practitioners', ...locationIds, parentLocationId, page, limit, searchValue],
  getPractitionersByPractitionerId: (practitionerId: string) => ['practitioners', practitionerId],
};

export const AppointmentTypesPractitionerQueryKeys = {
  getAppointmentTypePractitionersList: (locationIds: string[]) => ['appointmentTypesPractitioners', ...locationIds],
};

export const ScheduleEntriesQueryKeys = {
  getScheduleEntriesList: (locationId: string, entityIds: string[]) => ['scheduleEntries', locationId, ...entityIds],
};

export const CalendarEventsQueryKeys = {
  listCalendarEvents: ({
    limit,
    page,
    status,
    startDateTime,
    endDateTime,
    type,
    sortOrder,
  }: ListCalendarEventsParamsType) => [
    'calendarEvents',
    limit,
    page,
    status,
    type,
    startDateTime,
    endDateTime,
    sortOrder,
  ],
  listCalendarEventsMulti: ({
    startDateTime,
    endDateTime,
    locationIds,
    limit,
    page,
    sortOrder,
    status,
    type,
  }: ListCalendarEventsParamsType & { locationIds: string[] }) => [
    'calendarEventsMulti',
    ...locationIds,
    limit,
    page,
    status,
    startDateTime,
    endDateTime,
    sortOrder,
    type,
  ],
  listCalendarEventsByOwner: ({
    startDateTime,
    endDateTime,
    ownerId,
    limit,
    page,
    sortOrder,
  }: ListCalendarEventsParamsType & { ownerId: string }) => [
    'calendarEventsByOwner',
    ownerId,
    limit,
    page,
    status,
    startDateTime,
    endDateTime,
    sortOrder,
  ],
  getCalendarEvent: (eventId: string) => ['calendarEvents', eventId],
};
export const OperatoriesQueryKeys = {
  getOperatoriesList: (locationId: string, page?: string, limit?: string, searchValue?: string) => [
    'operatories',
    locationId,
    page,
    limit,
    searchValue,
  ],
  getOperatoriesListForMultiLocation: (
    locationIds: string[],
    parentLocationId: string,
    page?: string,
    limit?: string,
    searchValue?: string
  ) => ['operatories', ...locationIds, parentLocationId, page, limit, searchValue],
};
